<div class="container">
	<button class="back-button" (click)="goBack()">
		<mat-icon svgIcon="pm-icons:left-arrow" style="height: 12px; width: 12px" />
		Voltar
	</button>

	<ng-container *ngIf="!isOrderSuccess && !isLoading">
		<div class="form-container">
			<h1>Indicar restaurante</h1>

			<!-- Formulário -->
			<form [formGroup]="formControl">
				<h2>Restaurante</h2>
				<!-- Nome -->
				<div class="form-field">
					<input
						type="text"
						id="name"
						class="form-field__input"
						formControlName="name"
						(focus)="getFieldState('name').setFocused(true)"
						(blur)="getFieldState('name').setFocused(false)"
						[ngClass]="{
							focused: getFieldState('name').focused(),
							filled: formControl.controls.name.value,
							editing: getFieldState('name').editing(),
							error: formControl.controls.name.errors && formControl.controls.name.dirty
						}"
					/>
					<label for="name" class="form-field__label">Nome do restaurante</label>
					<span class="form-field__underline"></span>
					<div class="error-container">
						@if (
							formControl.controls.name.errors?.['required'] && formControl.controls.name.dirty
						) {
							<span class="error-message">Nome é obrigatório</span>
						}
					</div>
				</div>

				<!-- Website / Intagram -->
				<div class="form-field">
					<input
						type="text"
						id="website"
						class="form-field__input"
						formControlName="website"
						(focus)="getFieldState('website').setFocused(true)"
						(blur)="getFieldState('website').setFocused(false)"
						[ngClass]="{
							focused: getFieldState('website').focused(),
							filled: formControl.controls.website.value,
							editing: getFieldState('website').editing(),
							error: formControl.controls.website.errors && formControl.controls.website.dirty
						}"
					/>
					<label for="website" class="form-field__label">Site / Instagram do restaurante</label>
					<span class="form-field__underline"></span>
					<div class="error-container">
						@if (
							formControl.controls.website.errors?.['required'] &&
							formControl.controls.website.dirty
						) {
							<span class="error-message">Site / instagram é obrigatório</span>
						}
					</div>
				</div>
			</form>

			<!-- Buttons -->
			<ui-pm-footer-buttons type="fixed-order">
				<!-- Aceitação dos termos -->
				<div class="form-field-checkbox">
					<label for="terms" class="label-checkbox">
						<p>
							Pretendo utilizar meu
							<span style="color: var(--content-primary)">benefício celebrations</span> em um
							dos restaurantes indicados
						</p>
						<input
							type="checkbox"
							id="terms"
							[(ngModel)]="acceptedTerms"
							style="width: 20px; height: 20px"
						/>
					</label>
				</div>
				<button
					mat-raised-button
					[disabled]="!acceptedTerms || formControl.invalid"
					(click)="submitSuggestion()"
					class="footer-button"
				>
					Continuar
				</button>
			</ui-pm-footer-buttons>
		</div>
	</ng-container>

	<!-- Tela de sucesso -->
	<ng-container *ngIf="isOrderSuccess && !isLoading">
		<div class="success-container">
			<mat-icon svgIcon="pm-icons:check-circle" style="height: 80px; width: 80px"></mat-icon>
			<h1 class="success-title">Indicação enviada!</h1>
			<p class="success-subtitle">Obrigado, em breve entraremos em contato com os indicados.</p>
			<button mat-raised-button [routerLink]="'/'" class="success-button">Ver restaurantes</button>
		</div>
	</ng-container>

	<ng-container *ngIf="isLoading">
		<ui-pm-loading-page />
	</ng-container>
</div>
